import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactFlow, { ReactFlowProvider, Controls, isNode, } from 'react-flow-renderer';
import CustomNodeComponent from './CustomNodeComponent';
import './ProcessesDiagram.scss';
import dagre from 'dagre';

const position = { x: 0, y: 0 };

const ProcessesDiagram = ({ sandboxResult }) => {

    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    // eslint-disable-next-line security/detect-unsafe-regex
    const extensionRegex = /(?:\.([^.]+))?$/;

    const nodeWidth = 50;
    const nodeHeight = 70;
    let initialElements = [];

    const onLoad = (reactFlowInstance) => {
        return reactFlowInstance.fitView();
    };

    const checkForChildren = ( children, parent) => {

        return children.map((child) => {

            const node = {
                id: `horizontal-${child.pid}`,
                type: 'special',
                sourcePosition: 'right',
                targetPosition: 'left',
                data: {  text: `#${child.pid}`,
                    label: extensionRegex.exec(parent.process_name)[1].toUpperCase(),
                    filename: child.process_name
                },
                position: position,
            };

            const line = {
                id: `horizontal-el-${child.pid}`,
                source: `horizontal-${parent.pid}`,
                type: 'smoothstep',
                target: `horizontal-${child.pid}`,
            };

            initialElements.push(node);
            initialElements.push(line);

            child.children && checkForChildren(child.children, child);
        });
    };

    const processedElements = useMemo(() => {

        sandboxResult?.ProcessTree?.map((item) => {
            const parent = {
                id: `horizontal-${item.pid}`,
                type: 'special',
                sourcePosition: 'right',
                targetPosition: 'left',
                data: {  text: `#${item.pid}`,
                    label: extensionRegex.exec(item.process_name)[1].toUpperCase(),
                    filename: item.process_name
                },
                position: position,
            };

            initialElements.push(parent);

            if (item.children) {
                checkForChildren(item.children, item);
            }

            return initialElements;
        });

        return initialElements;

    }, [sandboxResult]);


    const getLayoutedElements = (elements, direction = 'LR') => {
        dagreGraph.setGraph({ rankdir: direction });

        elements.forEach((el) => {
            if (isNode(el)) {
                dagreGraph.setNode(el.id, { width: nodeWidth, height: nodeHeight });
            } else {
                dagreGraph.setEdge(el.source, el.target);
            }
        });

        dagre.layout(dagreGraph);

        return elements.map((el) => {
            if (isNode(el)) {
                const nodeWithPosition = dagreGraph.node(el.id);
                el.targetPosition =  'left';
                el.sourcePosition = 'right';

                el.position = {
                    x: (nodeWithPosition.x - nodeWidth / 2 + Math.random() / 1000) * 2,
                    y: nodeWithPosition.y - nodeHeight / 2,
                };
            }

            return el;
        });
    };

    const layoutedElements = getLayoutedElements(processedElements);

    const ReacFlowDom = useMemo(() => {
        if (!layoutedElements) {
            return;
        }
        return  <ReactFlowProvider>
            <ReactFlow
                elements={layoutedElements}
                connectionLineType="smoothstep"
                onLoad={onLoad}
                nodeTypes={{ special: CustomNodeComponent }}
                nodesDraggable={false}
                nodesConnectable={false}
            />
            <Controls className="controls"
                showInteractive={false}
            />
        </ReactFlowProvider>;
    }, [layoutedElements]);

    return (
        <div className="layoutflow">
            {ReacFlowDom}
        </div>
    );
};

ProcessesDiagram.propTypes = {
    sandboxResult: PropTypes.object,
};

export default ProcessesDiagram;
